module.exports = __webpack_public_path__ + "img/calendar-active.fcef2f69.svg";